import { useNavigate } from "react-router-dom";
import { IoMdReturnLeft } from "react-icons/io";

const LoginPcPage = () => {
    const navigate = useNavigate()
    const year = new Date().getFullYear();
    return (
        <div className="mobile_dashboard_container">

            <div className="mobile_dashboard_cont">
                <p className="title_mobile_dashboard_cont" onClick={() => navigate("/")}><span className="ia_span"></span>Project E8</p>
                <p>Project E8 Mobile will soon be available on the App Store and Google Play!</p>
                <p>In the meantime, you can access it from your PC.</p>

                <button className="back_home_btn" onClick={() => navigate("/")}> <i><IoMdReturnLeft /></i> Back to homepage</button>
            </div>
        </div>
    )
}

export default LoginPcPage